import { CollapsibleCard, TextField } from '@atgfr8/atg-ui-tailwind';
import { userRoles } from '@constants/common';
import { FeatureFlags } from '@constants/featureFlags';
import {
  customerDetailsStore,
  updateCustomerDetailsState,
} from '@store/customers/customerDetails';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { userStore } from '@store/user';
import { intersection } from 'lodash';
import { Show } from 'solid-js';

import { creditTaxEulerClasses as classes } from './classes';

const CreditTaxEuler = () => {
  const canSeeNegativeCredit = isFeatureFlagEnabled(
    FeatureFlags.ViewNegativeCredit,
  );

  const isReadonly = () => {
    return (
      intersection(userStore.user.roles, [
        userRoles.ADMIN,
        userRoles.ADMIN_LITE,
      ]).length <= 0
    );
  };

  return (
    <CollapsibleCard startTitle="Credit Limits & IDs" class="mb-2">
      <div class="p-3 flex gap-2 mr-3 bg-[#f1f6f9]!">
        <TextField
          label="Credit Limit"
          placeholder="Enter Credit Limit"
          type="number"
          showInCurrencyFormat
          value={customerDetailsStore.customer.creditLimit ?? ''}
          onChange={(val: unknown) =>
            updateCustomerDetailsState({ creditLimit: val as number })
          }
          class={classes.textFields}
          disabled={isReadonly()}
          maxLength={16}
          dataTestId="credit-tax-euler-credit-limit-textInput"
        />
        <Show when={canSeeNegativeCredit()}>
          <TextField
            label="Negative Credit Limit"
            placeholder="Enter Negative Credit Limit"
            type="number"
            showInCurrencyFormat
            value={customerDetailsStore.customer.negativeCreditAllowance ?? ''}
            onChange={(val: unknown) =>
              updateCustomerDetailsState({
                negativeCreditAllowance: val as number,
              })
            }
            on:blur={() => {
              const currentVal =
                customerDetailsStore.customer.negativeCreditAllowance;
              if (currentVal == null) {
                return;
              }
              const numVal = Number(currentVal);
              if (isNaN(numVal)) {
                updateCustomerDetailsState({ negativeCreditAllowance: null });
                return;
              }
              if (numVal > 0) {
                updateCustomerDetailsState({
                  negativeCreditAllowance: -numVal,
                });
              }
            }}
            class={classes.textFields}
            disabled={isReadonly()}
            maxLength={16}
            dataTestId="credit-tax-euler-negative-credit-limit-textInput"
          />
        </Show>
        <TextField
          label="Tax Id"
          placeholder="Enter Tax ID"
          value={customerDetailsStore.customer.taxId ?? ''}
          onChange={(val: string) => updateCustomerDetailsState({ taxId: val })}
          class={classes.textFields}
          disabled={isReadonly()}
          maxLength={11}
          dataTestId="credit-tax-euler-tax-id-textInput"
        />
        <TextField
          label="Euler Id"
          placeholder="Enter Euler ID"
          value={customerDetailsStore.customer.creditInsuranceId as number}
          onChange={(val: unknown) =>
            updateCustomerDetailsState({ creditInsuranceId: val as number })
          }
          class={classes.textFields}
          disabled={isReadonly()}
          maxLength={50}
          dataTestId="credit-tax-euler-euler-id-textInput"
        />
      </div>
    </CollapsibleCard>
  );
};

export default CreditTaxEuler;
